// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__35nRX","spinnerContainer":"Spinner_spinnerContainer__vvrcg"};